import { Button, ButtonGroup, ButtonVariant, HandleInteractionKind, Intent, MultiSlider, Popover, Position } from "@blueprintjs/core"
import { useId, useRef, useState } from "react"
import { ColorPicker } from "src/libs/useful"
import { IColorGradient, IGradient } from "src/libs/utilities/colors"
import getGradientCalc from "./getGradientCalc"

interface IGradientHandlerProps {
    data: IGradient
}
const GradientHandler = (props: IGradientHandlerProps): JSX.Element => {
    const [data, setData] = useState<IGradient>(props.data)
    const boxRef = useRef<HTMLDivElement>(null)
    const id = useId()
    const handleChange = (values: number[]) => {
        // console.log(values)
        if( values.length === data.colorStopList.length ) {
            let _data: IGradient = { ...data }
            _data.colorStopList = _data.colorStopList.map(( csl, i ) => {
                return { ...csl, position: `${values[i]}%` }
            })
            setData( _data )
        }
    }
    const onReleaseHandler =( newValue: number, n: number ) => {
        console.log( newValue, n )
    }
    
    const onClick = (evt: any ) => { 
        const offset = evt.target.getBoundingClientRect() 
        const newPos: number = Math.floor((evt.clientX - offset.left)/ offset.width * 100)
        let _data: IGradient = {...data}
        data.colorStopList.forEach((csl, i) => {
            if(
                parseInt( csl.position ) > newPos + 1 && 
                data.colorStopList[ i - 1 ] 
                    ? 
                    parseInt( data.colorStopList[i - 1].position ) < newPos - 1
                    :
                    false 
            ) {
                _data.colorStopList.splice(i, 0, { position: newPos + "%", color: getGradientCalc( data.colorStopList[i - 1], csl, newPos ) })
            }
        })
        setData( _data )
    }
    const onColor = ( color: any, csl: IColorGradient, i: number) => {
        console.log( color, csl, i )
        let _data: IGradient = {...data}
        _data.colorStopList[i].color = color
        setData( _data )
    }
    const onDelete = (i:number) => {
        if(data.colorStopList.length > 2) {
            let _data: IGradient = {...data}
            _data.colorStopList.splice(i, 1)
            setData( _data )
        }
    } 
    const getLeft = (n: number) : number => {
        try {
            var element = document.querySelector(`[aria-label="handle_${id}_${ n }"]`)
            var style = getComputedStyle( element! );
            var left = style?.getPropertyValue("left") || ""
            console.log( left )
            return parseInt(left) - 7
        }
        catch {
            return 0
        }
        
    }
    return <div className="pe-gradient-handler-container w_150">
        <div className='position-relative' style={{height: 20}}>
        {
            data.colorStopList.map((csl, i) => {
                return <div
                    key={i}
                    style={{   
                        position: "absolute",
                        top: 0,
                        left: getLeft(i)
                    }}
                >
                    <Popover position={Position.TOP} content={ <div className="p-1">
                        <ColorPicker color={ csl.color} onChoose={( color: any ) => onColor(color, csl, i)} />
                        <div className="d-flex">
                            {
                                data.colorStopList.length > 2 && <ButtonGroup >
                                    <Button variant={ButtonVariant.MINIMAL}  icon="trash" onClick={ ()=> onDelete(i) }/>
                                </ButtonGroup>
                            } 
                            <input 
                                type="string" 
                                className='flex-grow-100 w-100'
                                value={ csl.color } 
                                onChange={ (evt) => onColor(evt.currentTarget.value, csl, i) } 
                            /> 
                        </div>
                    </div> } >            
                        <div 
                            className='pe-color-picker-example' 
                            style={{
                                backgroundColor: csl.color, 
                                height: 13, 
                                margin: "0 0 0 4px",
                                width: 13, 
                            }}
                        /> 
                    </Popover> 
                </div>
            })
        }
        </div>
        <MultiSlider
            defaultTrackIntent={Intent.SUCCESS}
            labelStepSize={200}
            max={100}
            min={0}
            onChange={handleChange} 
            stepSize={1} 
            vertical={false}
            labelRenderer={ false }
            showTrackFill={false}
        >
            {
                data.colorStopList.map((csl, i) => {
                    return <MultiSlider.Handle
                        key={ i }
                        type="full"
                        value={ parseInt( csl.position ) }
                        intentBefore="danger"
                        interactionKind={ HandleInteractionKind.PUSH }
                        htmlProps={{ "aria-label": `handle_${id}_${ i }` }}
                        onRelease={newVal => onReleaseHandler(newVal, i)}
                    />
                })
            } 
        </MultiSlider>
        <div 
            style={{
                width: "100%",
                height: 7,
                background: `linear-gradient(to right, ${ data.colorStopList.map(scl => scl.color + " " + scl.position).join(",") })`
                
            }}
            className='pe-color-picker-example111'
            ref={ boxRef }
            onClick={ onClick }
        >

        </div>
    </div>
}

export default GradientHandler